<template>
  <v-content class="mt-7 ml-7 mr-7">
    <v-container grid-list-md class="pb-0">
      <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Periodos</v-toolbar-title>
            <v-divider class="mx-3" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Agregar Periodo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex d-flex xs12 sm12 md8>
                        <v-text-field v-model="editedItem.periodo" label="Nuevo periodo"></v-text-field>
                      </v-flex>
                       <v-flex xs12 sm4 d-flex>
                          <v-select
                            v-model="editedItem.idTipoPeriodo"
                            :items="ddlTperiodo"
                            item-text="tipoPeriodo"
                            item-value="idTipoPeriodo"
                            label="Clasificacion Perido"
                            outlined
                          ></v-select>
                          </v-flex>
                      <v-flex xs12 sm3 d-flex>
                        <v-select
                          v-model="editedItem.estatusPeriodo"
                          :items="estatusPeriodo"
                          item-text="state"
                          item-value="value"
                          label="Estatus"
                          outlined
                        ></v-select>
                      </v-flex>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.fIncio"
                                label="Fecha de inicio"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.fIncio"   locale="mx" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" sm="6" md="4">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.fFin"
                                label="Fecha Final"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                              <v-date-picker v-model="editedItem.fFin"  locale="mx" @input="menu2 = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-spacer></v-spacer>
                      </v-row>
                    </v-layout>
                  </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                </v-card-actions>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.estatusPeriodo="{ item }">
          <v-btn
            depressed
            small
            :color="getColor(item.estatusPeriodo)"
            dark
            @click="modalaplica(item)"
          >{{gettxt(item.estatusPeriodo)}}</v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </v-content>
</template>

<script>
import axunidad from "axios";
import { async } from "q";

import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let apiUrl = 'https://localhost:44340/'
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'

export default {
  data: () => ({
    
    menu: false,
    modal: false,
    menu2: false,
    dialog: false,
    estatusPeriodo: [
      { state: "Activo", value: 1 },
      { state: "No Activo", value: 2 },
      { state: "Fuera de Periodo", value: 3 }
    ],
    headers: [
      { text: " Periodo", value: "periodo" },
      { text: " Inicio", value: "fIncio" },
      { text: " Fin", value: "fFin" },
      { text: " Estatus", value: "estatusPeriodo" },
      { text: "Acción", value: "action", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      // fIncio :  new Date().toISOString().substr(0, 10).split(" ")[0].split("-").reverse().join("-"),
      // fFin : new Date().toISOString().substr(0, 10).split(" ")[0].split("-").reverse().join("-"),
    fIncio: new Date().toISOString().substr(0, 10),
    fFin: new Date().toISOString().substr(0, 10),
      periodo: "",
      idPeriodo: 0
    },
    defaultItem: {
      periodo: "",
      idPeriodo: 0
    },
    respddl: [],
    items: [],
    ddlTperiodo: []

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Perido " : "Editar Periodo";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    let self = this;
    self.initialize();
  },

  methods: {
    getColor(estatus) {
      //  console.log("color aplica", aplica);
      if (estatus == 1) {
        return "green";
      } else if (estatus == 2) {
        return "red";
      }else if (estatus == 3) {
        return "orange";
      }
    },

    gettxt(estatus) {
      //  console.log("aplica txt", aplica);
      if (estatus == 1) {
        return "Activo";
      } else if (estatus == 2) {
        return "No activo";
      }
       else if (estatus == 3) {
        return "Fuera  de periodo ";
      }
    },

    initialize() {
      let self = this;

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getCatPeriodo().then(r => {
        // this.desserts = r.data.data;
           this.desserts = r.data.data.map(e => {
            e.fIncio = e.fIncio.substr(0,10).split(" ")[0].split("/").reverse().join("/");
            e.fFin = e.fFin.substr(0,10).split(" ")[0].split("/").reverse().join("/");
              // console.log("pos si", e.fIncio)
            return e
     
    });

        console.log("cat perido ini", this.desserts);
         self.ddlTipoPeriodo();
      });

      //   self.ddlfraccion()
    },

    async editItem(item) {
      var nitem=[];
      this.editedIndex = this.desserts.indexOf(item);
        console.log("item",item);
        if ( item.fIncio==null ||  item.fFin==null ) {
            this.editedItem = Object.assign({}, item);
            console.log(this.editedItem);
            this.dialog = true;
        } else {
        nitem={idPeriodo:item.idPeriodo, 
        periodo:item.periodo,
        idTipoPeriodo: item.idTipoPeriodo,
        estatusPeriodo: item.estatusPeriodo,
        fIncio: item.fIncio.substr(0,10 ),
        fFin: item.fFin.substr(0,10 )}
        console.log("nitem",nitem);
      this.editedItem = Object.assign({}, nitem);
      console.log(this.editedItem);
      this.dialog = true;
        }
       
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
       let self = this;
     console.log(item);
      confirm("Eliminar Periodo?") &&
        this.desserts.splice(index, 1);
         var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .deletePeriodo(item.idPeriodo)
          .then(r => {
            r.data;
          })
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
       console.log(this.editedItem);
      let selft = this;
      if (this.editedIndex > -1) {
        //Editar periodo 
        let self = this;
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .updatePeriodo(self.editedItem)
          .then(r => {
            r.data;
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      } else {
        //Guardar periodo
        this.desserts.push(this.editedItem);
        let self = this;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .addPeriodo(self.editedItem)
          .then(r => {
            self.initialize();
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      }
      this.close();
    },
    //ddl tipo peridodo 
        ddlTipoPeriodo() {
        let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getTipoPeriodo().then(c => {
        this.ddlTperiodo = c.data;
        console.log("tipoperido", this.ddlTperiodo);
       });

    }
  }
};
</script>

